import { FC, ReactNode, useState } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import { Tooltip } from 'antd';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import { TableLineIcon, TablePlusIcon, TableNormalIcon, TableCheckIcon, TableTipsIcon } from '@/components/EcoCredits/Svg';

export type tableItem = {
    icon: () => ReactNode;
    text: string;
    tips?: string;
    linkText?: string;
    key?: string;
    onlyPlus?: boolean;
};

interface IBenefitsTableProps {
    list: tableItem[];
    handleTools: (key?: string) => void;
}

const BenefitsTable: FC<IBenefitsTableProps> = ({ list, handleTools }) => {
    const { t } = useLang('ecocredits.ecoflowbenefits');
    const { rewardUserLevel, isLogin } = useMonthlyStore();

    return (
        <div className={styled.BenefitsTable}>
            <ul className="table-header">
                <li>
                    <span className="left-bottom">{t('ecoflowbenefits_tab_benefits')}</span>
                    <TableLineIcon />
                    <span className="right-top">{t('ecoflowbenefits_tab_tier')}</span>
                </li>
                <li>
                    <TablePlusIcon />
                    <span>{rewardUserLevel?.plusName}</span>
                </li>
                <li>
                    <TableNormalIcon />
                    <span>{rewardUserLevel?.normalName}</span>
                </li>
            </ul>
            <div>
                {list
                    .filter((item) => (!isLogin ? !item.key : true)) // 未登录的时候 三个存在按钮的均不显示
                    .map((item, index) => (
                        <ul className="table-body" key={item.text + index} style={{ background: index % 2 !== 1 ? '#FFFEFA' : '#FFF9F2' }}>
                            <li>
                                {item.icon && <span className="table-icon">{item.icon()}</span>}
                                <span className="table-text">
                                    {item.text}
                                    {item.tips && (
                                        <Tooltip placement="bottom" title={item.tips}>
                                            <TableTipsIcon />
                                        </Tooltip>
                                    )}
                                    {item.linkText && (
                                        <EditorLink className="table-text-link" onClick={() => handleTools(item.key)}>
                                            {item.linkText}
                                        </EditorLink>
                                    )}
                                </span>
                            </li>
                            <li>
                                <TableCheckIcon />
                            </li>
                            <li>{item.onlyPlus ? '-' : <TableCheckIcon />}</li>
                        </ul>
                    ))}
            </div>
        </div>
    );
};

export default BenefitsTable;
